import { z } from "zod";

/**
 * Webhook signing (PREC-4249). The secret itself reaches the browser only in the responses that
 * show it once: create, rotate, and the one-time reveal of a webhook created before signing.
 */

/** The Signing column: "not-viewed" is a secret nobody has seen yet, revealable once. */
export const WebhookSigningStatusSchema = z.object({
	state: z.enum(["signed", "not-viewed"]),
	secretCreatedAt: z.string().nullable(),
	/** The end of a rotation's overlap, while it lasts. */
	previousSecretValidUntil: z.string().nullable(),
	revealable: z.boolean(),
});

/** The answer of rotate and reveal: the secret, shown once. */
export const WebhookSecretResponseSchema = z.object({
	signingSecret: z.string(),
	previousSecretValidUntil: z.string().nullable(),
});

/** "Send test event": what the receiver did, and exactly what was sent (URL masked). */
export const WebhookTestEventResultSchema = z.object({
	delivered: z.boolean(),
	status: z.number().nullable(),
	outcome: z.string(),
	responseBody: z.string().nullable(),
	durationMs: z.number(),
	sent: z.object({
		url: z.string(),
		headers: z.record(z.string(), z.string()),
		body: z.string(),
	}),
});

export type WebhookSigningStatus = z.infer<typeof WebhookSigningStatusSchema>;
export type WebhookSecretResponse = z.infer<typeof WebhookSecretResponseSchema>;
export type WebhookTestEventResult = z.infer<typeof WebhookTestEventResultSchema>;
